module.exports = __webpack_public_path__ + "static/media/Alias Concept.6374f76d.png";